import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
  } from "../../config/axiosInstance";
  
export const articleListApi = async (data) => {
  const endPoint = `admin/article/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
  
export const articleDetailApi = async (data) => {
  const endPoint = `admin/article?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

export const addArticleApi = async (data) => {
    const endPoint = `admin/article`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};

export const updateArticleApi = async (data) => {
    const endPoint = `admin/article`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};

export const deleteArticleApi = async (data) => {
  const endPoint = `admin/article?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.delete(endPoint, setJwtToken());
};



export const articleCategoryListApi = async (data) => {
    const endPoint = `admin/article-category/list?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.get(endPoint, setJwtToken());
  };
    
  export const articleCategoryDetailApi = async (data) => {
    const endPoint = `admin/article-category?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.get(endPoint, setJwtToken());
  };
  
  export const addArticleCategoryApi = async (data) => {
      const endPoint = `admin/article-category`;
      return await axios.post(endPoint, data, setMultiPartHeader());
  };
  
  export const updateArticleCategoryApi = async (data) => {
      const endPoint = `admin/article-category`;
      return await axios.put(endPoint, data, setMultiPartHeader());
  };
  
  export const deleteArticleCategoryApi = async (data) => {
    const endPoint = `admin/article-category?${new URLSearchParams(
      data
    ).toString()}`;
    return await axios.delete(endPoint, setJwtToken());
  };